import { render, staticRenderFns } from "./memberRight.vue?vue&type=template&id=5bc455d8&scoped=true&"
import script from "./memberRight.vue?vue&type=script&lang=js&"
export * from "./memberRight.vue?vue&type=script&lang=js&"
import style0 from "./memberRight.vue?vue&type=style&index=0&id=5bc455d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc455d8",
  null
  
)

export default component.exports